<template>
  <div class="mall-page">
    <section class="page-banner mall-banner">
      <span class="eyebrow light">TRAOUT / OFFICIAL STORES</span>
      <h1>{{ heading.title || '线上商城' }}</h1>
      <p>{{ heading.body || '选择官方商城，开启你的户外探索。' }}</p>
    </section>

    <section class="mall-section" v-loading="loading">
      <el-alert v-if="loadError" :title="loadError" type="error" :closable="false" show-icon />
      <div v-if="stores.length" class="mall-grid">
        <a
          v-for="store in stores"
          :key="store.contentKey"
          class="mall-card"
          :href="store.body"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="mall-card-image">
            <img :src="store.imageUrl" :alt="store.title" loading="lazy">
            <span class="mall-card-arrow" aria-hidden="true">↗</span>
          </div>
          <h2>{{ store.title }}</h2>
        </a>
      </div>
      <el-empty v-else-if="!loading && !loadError" description="线上商城信息正在准备中，敬请期待。" />
    </section>
  </div>
</template>

<script>
import { getPortal } from '../api'

export default {
  data: () => ({ contents: [], loading: true, loadError: '' }),
  computed: {
    heading() {
      return this.contents.find(item => item.contentKey === 'mall.heading') || {}
    },
    stores() {
      return this.contents.filter(item =>
        item.contentKey.startsWith('mall.store.')
        && item.title
        && item.imageUrl
        && this.isSafeExternalUrl(item.body)
      )
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      try {
        const data = await getPortal()
        this.contents = data.contents || []
      } catch (error) {
        this.contents = []
        this.loadError = '商城信息加载失败，请稍后重试。'
      } finally {
        this.loading = false
      }
    },
    isSafeExternalUrl(value) {
      try {
        const url = new URL(value)
        return ['http:', 'https:'].includes(url.protocol) && Boolean(url.hostname) && !url.username && !url.password
      } catch (error) {
        return false
      }
    }
  }
}
</script>
